import React, { PureComponent } from 'react';
import { Redirect, withRouter } from 'react-router-dom';

import Topbar from '../../components/Navigation/Topbar/Topbar';
import RedirectUtilityWrapper from '../../hoc/RedirectUtilityWrapper/RedirectUtilityWrapper';

import classes from './MainLayout.module.css';
import { AddInLocalStorage, ClearLocalStorage, GetFromLocalStorage, IsListEmpty, IsObjectEmpty, IsStringEmpty } from '../../utilities/CommonMethods';
import TopbarProgramStrip from '../../components/TopbarProgramStrip/TopbarProgramStrip';
import VerticalNavBar from '../../components/Navigation/VerticalNavBar/VerticalNavBar';

import RouteEndPoints from '../../utilities/RouteEndPoints';
import { connect } from 'react-redux';

import SignInModalForm from '../../components/Forms/SignInModalForm/SignInModalForm';
import ForgotPasswordModalForm from '../../components/Forms/ForgotPasswordModalForm/ForgotPasswordModalForm';
import FlexModal from '../../components/UI/FlexModal/FlexModal';

import * as actionCreators from '../../store/actions/index';
import ResourceAPIController from '../../webServices/ResourceAPIController';
import UserAPIController from '../../webServices/UserAPIController';
import LiveSessionPopup from '../../components/Popups/LiveSessionPopup/LiveSessionPopup';
import Constants from '../../utilities/Constants';
// import { Link } from "react-router-dom";
import ContactSupportIcon from '../../components/ContactSupportIcon/ContactSupportIcon';
// import DailyFeedbackPupup from '../../components/Popups/DailyFeedbackPupup/DailyFeedbackPupup';
// import NewDailyFeedbackPupup from '../../components/Popups/NewDailyFeedbackPupup/NewDailyFeedbackPopup';
import NotificationPopup from '../../components/Popups/NotificationPopup/NotificationPopup';
import NotificationToast from '../../components/UI/NotificationToast/NotificationToast';
import { getFullDateTime, parseDate } from '../../utilities/DateTimeUtils';
import axios from 'axios';
import EdyodaDigitalImage from '../../assets/Design Images/Cards/Slide01-Digital-Classroom - Copy.png'
// import Rocket from "../../assets/Design Images/Cards/rocket-joypixels.gif";

class MainLayout extends PureComponent {

    state = {
        signInLoading: false,
        forgotPasswordModalOpen: false,
        notificationsDropDownOpen: false,
        notifications: {
            notificationsList: [],
            unreadNotifCountTotal: 0,
            unreadNotifCountAnnouncement: 0,
            unreadNotifCountImportant: 0,
            unreadNotifCountNotification: 0
        },
        showNotificationLoader: false,
        profileDropDownOpen: false,
        showLiveSessionPopup: false,
        liveSessionId: 0,
        continueLearningData: {},

        showAlertDialog: false,
        alertDialogMessage: 'Your session has expired please login again',
        alertDialogButtonLabel: 'OKAY',
        forLearner: false,
        previousTopicFeedback: [],
        countChanged: false,
        showPopup: false,
        showToast: false,
        notificationData: '',
        lastToastPopupShowTime: Date.now(),
        hideProgramStrip: true
    }

    handleError = (err) => {
        if (IsObjectEmpty(err.error)) {
            // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
            return;
        }
        if (err.error.status === 400) {
            this.props.onFailureDialogShow(err.error.message, 'OKAY');
        }
        if (err.error.status === 401) {
            if (err.error.message === 'Invalid token.') {
                this.props.showSessionExpiredDialog(true);
            } else {
                this.props.redirectToUnauthorized();
            }
        }
        if (err.error.status === 404) {
            this.props.redirectToNotFound();
        }
        if (err.error.status === 500) {
            this.props.redirectToServerError();
        }
    }

    onProfileAvatarClick = () => {
        const updatedState = !this.state.profileDropDownOpen;
        this.setState({ profileDropDownOpen: updatedState, });
    }

    onNotificationIconClick = (notificationId, viewed, index) => {
        const updatedState = this.state.notificationsDropDownOpen;
        if (updatedState === false) {
            let responseObj = null;

            this.setState({ notificationsDropDownOpen: !updatedState, showNotificationLoader: true, profileDropDownOpen: false, countChanged: false });
            UserAPIController.getDropdownNotifications(true)
                .then(response => {
                    responseObj = response.result;
                    this.setState({
                        notifications: {
                            notificationsList: response.result.updatedNotificationsList,
                            unreadNotifCountTotal: response.result.unreadNotifCountTotal,
                            unreadNotifCountAnnouncement: response.result.unreadNotifCountAnnouncement,
                            unreadNotifCountImportant: response.result.unreadNotifCountImportant,
                            unreadNotifCountNotification: response.result.unreadNotifCountNotification
                        },
                        showNotificationLoader: false
                    });
                })
                .catch(err => {
                    console.log('Get Dropdown Notifications Error => ', err)
                    this.setState({ showNotificationLoader: false });
                    this.handleError(err);
                });
        } else {
            if (!IsStringEmpty(index) && !IsStringEmpty(notificationId) && !viewed) {
                this.markReadOnServer(notificationId);
            }

            const selectedNotificationData = this.state.notifications.notificationsList[index];

            if (!IsObjectEmpty(selectedNotificationData) && !IsStringEmpty(selectedNotificationData.url)) {
                this.setState({ notificationsDropDownOpen: !updatedState, showNotificationLoader: false, profileDropDownOpen: false });
            } else if (!IsObjectEmpty(selectedNotificationData)) {
                this.setState({ notificationsDropDownOpen: !updatedState, showNotificationLoader: false, profileDropDownOpen: false, notificationData: selectedNotificationData, showPopup: true });
            } else {
                this.setState({ notificationsDropDownOpen: !updatedState, showNotificationLoader: false, profileDropDownOpen: false });
            }
        }


    }

    markReadOnServer = (notificationId) => {
        UserAPIController.markNotificationAsRead(notificationId)
            .then(response => {
                this.props.setUnreadNotifCount(this.props.unreadNotifCount - 1);
            })
            .catch(error => {
                Error('Failed to MarkAsRead Notifications');
            });
    }

    onViewAllNotificationsClick = () => {
        this.setState({ notificationsDropDownOpen: false, profileDropDownOpen: false });

        if (!IsObjectEmpty(this.props.location) && !IsStringEmpty(this.props.location.pathname) && this.props.location.pathname === '/notifications') {
            return;
        } else {
            this.props.history.push({ pathname: RouteEndPoints.ALL_NOTIFICATIONS });
        }
    }

    setBasicUserDetails = (userDetails) => {
        this.props.setBasicUserDetails(userDetails);
        this.getCommonData();
    }

    handleNotifications = (notifList) => {
        // Popup or Toast show conditions
        // 1. already a popup or tast is not visible
        // 2. A last popup or tast was shown 15 sec before
        // 3. We have a toast or popup type notification which is not viewed yet and not expired yet

        // const unreadToastPopupNotification = !IsListEmpty(notifList) ? notifList.find(notif => notif.viewed !== true && (notif.type === 'popup' || notif.type === 'toast')) : {};
        const unreadToastPopupNotification = !IsListEmpty(notifList) ? notifList[0] : {};


        if (!IsObjectEmpty(unreadToastPopupNotification)) {
            if (((Date.now() - this.state.lastToastPopupShowTime) > (15 * 1000))) { // 15 Seconds to show next notification
                if (unreadToastPopupNotification.type === "popup" && this.state.showPopup !== true && this.state.showToast !== true) {
                    // console.log('showing notif popup')
                    this.setState({
                        showPopup: true,
                        notificationData: unreadToastPopupNotification,
                        lastToastPopupShowTime: Date.now()
                    })
                } else if (unreadToastPopupNotification.type === "toast" && this.state.showToast !== true && this.state.showPopup !== true) {
                    // console.log('showing notif toast')
                    this.setState({
                        showToast: true,
                        notificationData: unreadToastPopupNotification,
                        lastToastPopupShowTime: Date.now()
                    })
                }
            }
        }
    }

    checkInterval = null;

    setNotificationTimer = (clearPreviousInterval) => {

        if (this.checkInterval !== null && clearPreviousInterval === true) {
            // console.log("Interval is getting cleared - Clear Previous")
            clearInterval(this.checkInterval);
        }

        this.checkInterval = setInterval(() => {

            const currentTime = Date.now();
            const localDate = parseDate(new Date());
            const afterDateTime = new Date(localDate + ' 21:45:00').getTime(),
                beforeDateTime = new Date(localDate + ' 18:00:00').getTime();

            const timeIsValid = afterDateTime < currentTime || currentTime < beforeDateTime; // Notifications should be stopped between 6:00 PM to 9:45 PM

            // console.log('timeIsValid V: ', timeIsValid);
            // console.log('timeIsValid B: ', new Date(beforeDateTime));
            // console.log('timeIsValid C: ', new Date(currentTime));
            // console.log('timeIsValid A: ', new Date(afterDateTime));

            if (timeIsValid) {
                // console.log("Interval is live making api request", new Date())
                UserAPIController.getRecentNotifications(true)
                    .then(response => {

                        const countChanged = ((this.state.notifications.unreadNotifCountTotal !== response.result.unreadNotifCountTotal) && response.result.unreadNotifCountTotal > 0 || this.state.countChanged);


                        this.handleNotifications(response.result.updatedNotificationsList);

                        const updatedNotifications = { ...this.state.notifications };
                        updatedNotifications.unreadNotifCountTotal = response.result.unreadNotifCountTotal;


                        this.setState({
                            notifications: updatedNotifications,
                            notificationData: response.result.updatedNotificationsList[0],
                            countChanged: countChanged,
                            showNotificationLoader: false
                        });
                    })
                    .catch(err => {
                        console.log('Get Dropdown Notifications Error => ', err)
                    });
            }

            if (GetFromLocalStorage(Constants.KEY_USER_LOGGED_IN) !== 'true') {
                // console.log("Interval is getting cleared - not logged in")
                clearInterval(this.checkInterval);
            }
        }, 8000);
    }

    getCommonData = () => {

        this.setState({ signInLoading: true });
        let responseObj = null;


        const isLearner = GetFromLocalStorage(Constants.KEY_IS_LEARNER) === 'true' ? true : false;
        if (isLearner === true) {
            this.setState({ forLearner: true, hideProgramStrip: this.props.hideProgramStrip })
        }
        const isProgramManager = GetFromLocalStorage(Constants.KEY_IS_PROGRAM_MANAGER) === 'true' ? true : false;

        if (!IsStringEmpty(GetFromLocalStorage(Constants.KEY_IS_LEARNER)) && isLearner) {
            ResourceAPIController.userPostLoginData()
                .then(response => {

                    responseObj = response.result;

                    this.props.setInitialProgramData(responseObj.continueLearningData, responseObj.ongoingProgram, responseObj.enrolledPrograms);

                    // let hideStrip = responseObj.ongoingProgram.type !== 'micro_degree';
                    if (responseObj.ongoingProgram.programId !== this.props.activeProgramId && IsStringEmpty(this.props.activeProgramId)) {
                        this.props.setActiveProgramId({
                            id: responseObj.ongoingProgram.programId,
                            batchCode: responseObj.ongoingProgram.programBatchCode,
                            type: responseObj.ongoingProgram.type
                        });
                        this.props.setBasicUserDetails(responseObj.userDetails);
                        // AddInLocalStorage(Constants.KEY_PROGRAM_STRIP, hideStrip);
                    }
                    this.setState({
                        signInLoading: false,
                        continueLearningData: responseObj.continueLearningData,
                        previousTopicFeedback: responseObj.previousTopicFeedback,
                        // hideProgramStrip: hideStrip
                    });

                    if (isLearner === true) {
                        this.setNotificationTimer(false);
                    }
                })
                .catch(err => {
                    console.log('Post Login Data error => ', err)
                    this.setState({ signInLoading: false });
                    this.handleError(err);
                });
        } else if (isProgramManager) {
            ResourceAPIController.getProgramManagerData()
                .then(response => {
                    let responseObj = response.result
                    this.setState({
                        signInLoading: false,
                        accessReports: responseObj.userDetails.accessInstructorReports,
                        hideProgramStrip: true
                    })
                    AddInLocalStorage(Constants.KEY_PROGRAM_STRIP, true);
                    this.props.setBasicUserDetails(responseObj.userDetails);
                })
                .catch(err => {
                    console.log('[ MainLayout ] Post Login Data Program Manager error => ', err)
                    this.setState({ signInLoading: false });
                    this.handleError(err);
                });
        }
        else if (!IsStringEmpty(GetFromLocalStorage(Constants.KEY_IS_LEARNER))) {

            ResourceAPIController.userPostLoginDataInstructor()
                .then(response => {

                    let responseObj = response.result;
                    // console.log('[ MainLayout ] Post Login Data Instructor Response => ', responseObj)

                    this.props.setInitialModuleData(responseObj.moduleOverviewData, responseObj.ongoingModuleData, responseObj.enrolledModules);


                    if (responseObj.ongoingModuleData.programId !== this.props.activeProgramId && IsStringEmpty(this.props.activeProgramId)) {
                        this.props.setActiveModuleId({
                            id: responseObj.ongoingModuleData.moduleId,
                            batchCode: responseObj.ongoingModuleData.batchCode,
                            moduleName: responseObj.ongoingModuleData.moduleName
                        });
                        this.props.setBasicUserDetails(responseObj.userDetails);
                    }
                    this.setState({
                        signInLoading: false,
                        moduleOverviewData: responseObj.moduleOverviewData,
                        ongoingModuleData: responseObj.ongoingModuleData,
                        hideProgramStrip: true
                    });
                    AddInLocalStorage(Constants.KEY_PROGRAM_STRIP, true);
                })
                .catch(err => {
                    console.log('[ MainLayout ] Post Login Data Instructor error => ', err)
                    this.setState({ signInLoading: false });
                    this.handleError(err);
                });
        }


        this.props.onUserLoginSuccess();
    }

    logOutClicked = () => {
        this.setState({ signInLoading: true });
        UserAPIController.userLogout()
            .then(response => {
                ClearLocalStorage();
                this.props.onUserLoggedOut();

                if (this.checkInterval !== null) {
                    // console.log("Interval is getting cleared - logout")
                    clearInterval(this.checkInterval);
                }
            })
            .catch(err => {
                console.log('Logout Data error => ', err)
                this.setState({ signInLoading: false });
                this.handleError(err);
            });
    }

    onAlertDialogHide = () => {
        this.setState({ showAlertDialog: false, alertDialogMessage: 'Your session has expired please login again' });
        ClearLocalStorage();
        this.props.onUserLoggedOut();
        window.location.href = RouteEndPoints.LOGIN_PAGE;
    }

    onModalCloseButtonClick = () => {
        this.props.hideSignInPopup();
    }

    onResetPasswordLinkClick = () => {
        // this.setState({ signInModalOpen: false, forgotPasswordModalOpen: true });
        this.props.hideSignInPopup();
        this.props.showForgotPasswordModal();
    }

    showLiveSessionPopup = (liveSessionId) => {
        this.setState({ showLiveSessionPopup: true, liveSessionId: liveSessionId });
    }

    hideLiveSessionPopup = () => {
        this.setState({ showLiveSessionPopup: false, liveSessionId: 0 });
    }

    closePopup = () => {
        let updatedPreviousTopicFeedback = this.state.previousTopicFeedback;
        updatedPreviousTopicFeedback.feedbackSubmitted = true;
        this.setState({ previousTopicFeedback: updatedPreviousTopicFeedback });
    }

    closeNotifButtonClick = (data, action) => {
        this.setState({ showToast: false, showPopup: false, lastToastPopupShowTime: Date.now(), countChanged: false });
        this.markReadOnServer(this.state.notificationData.id);
        if (!IsObjectEmpty(data)) {
            this.logNotificationDataOnFirebase(data, action);
        }
    }

    logNotificationDataOnFirebase = (data, action) => {
        const email = GetFromLocalStorage(Constants.KEY_EMAIL);
        let postData = {
            email: email,
            dateTime: new Date(),

            notifTitle: data.label,
            notifType: data.type,
            notifDateTime: data.dateTime,
            notifDue: data.dueDate,
            notifURL: data.url,

            action: action,
            pageURL: window.location.pathname,
            batchCode: this.props.activeProgramBatchCode
        }
        axios.post('https://classroom-notifications-ae74c-default-rtdb.asia-southeast1.firebasedatabase.app/learner-notifications.json', postData);
    }

    showMDStudentPopup = () => {
        // this.setState({ showMDStudentPopup: true });
        alert('This feature is only application for Intesive Career Program students.')
    }

    componentDidMount() {
        if (this.props.userLoggedIn) {
            this.getCommonData();
        }

        // const zoomMeeting = document.getElementById("zmmtg-root");
        // if (zoomMeeting !== undefined && zoomMeeting !== null && window.location.href.indexOf('join-live-session') !== -1) {
        //     zoomMeeting.remove();
        // }
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.userLoggedIn !== this.props.userLoggedIn) && !this.props.userLoggedIn) {
            this.props.history.push({ pathname: '/' })
        }

        // const isLearner = GetFromLocalStorage(Constants.KEY_IS_LEARNER) === 'true' ? true : false;

        // const localStorageStripStatus = GetFromLocalStorage(Constants.KEY_PROGRAM_STRIP) === 'true';
        // let updatedTopbarStripStatus = this.state.hideProgramStrip;

        // if (isLearner) {
        //     if (this.props.location.pathname.indexOf('join-live-session') > -1
        //         || this.props.location.pathname.indexOf('submit-feedback') > -1
        //         || this.props.location.pathname.indexOf('start-quiz') > -1
        //         || this.props.location.pathname.indexOf('login') > -1) {
        //         updatedTopbarStripStatus = true;
        //         AddInLocalStorage(Constants.KEY_PROGRAM_STRIP, true);
        //         this.props.hideTopbarStrip(true);
        //     } else {
        //         if (this.props.ongoingProgram.type !== prevProps.ongoingProgram.type || this.props.activeProgramBatchCode !== prevProps.activeProgramBatchCode) {
        //             updatedTopbarStripStatus = this.props.ongoingProgram.type === "micro_degree" ? false : true;
        //             AddInLocalStorage(Constants.KEY_PROGRAM_STRIP, updatedTopbarStripStatus);
        //             this.props.hideTopbarStrip(updatedTopbarStripStatus);
        //             this.setState({ hideProgramStrip: updatedTopbarStripStatus });
        //         }
        //     }
        // } else {
        //     updatedTopbarStripStatus = true;
        //     AddInLocalStorage(Constants.KEY_PROGRAM_STRIP, updatedTopbarStripStatus);
        //     this.setState({ hideProgramStrip: updatedTopbarStripStatus });
        // }
    }

    hideProgramStrip = () => {
        this.setState({ hideProgramStrip: true });
        AddInLocalStorage(Constants.KEY_PROGRAM_STRIP, true);
        this.props.hideTopbarStrip(true);
    }

    logDataOnFirebase = () => {
        const email = GetFromLocalStorage(Constants.KEY_EMAIL),
            username = GetFromLocalStorage(Constants.KEY_USERNAME),
            batchCode = this.props.activeProgramBatchCode;


        let data = {
            username: username,
            email: email,
            dateTime: getFullDateTime(new Date()),
            batchCode: batchCode,
            pageURL: window.location.pathname,
        }
        axios.post(Constants.FIREBASE_CLASSROOM_LOGS + 'topbar-strip-tracking.json', data);
    }

    render() {
        let topbarTheme = classes.Light;
        if (!IsStringEmpty(this.props.userLoggedIn) && this.props.userLoggedIn === false) {
            topbarTheme = classes.Dark;
        } else if (!IsStringEmpty(this.props.userLoggedIn) && this.props.userLoggedIn === true) {
            topbarTheme = classes.Light;
        }
        return (
            <div>

                {false ? null : null}

                {
                    this.state.hideProgramStrip ? null
                        : <div className={classes.TopStrip}>
                            <a href={Constants.UNIVERSITY_HOMEPAGE} target='_blank' className={classes.RemoveTextDecoration} onClick={this.logDataOnFirebase}>
                                Assured Job Opportunity Programs! <span>Know More</span>
                            </a>
                            <span className={classes.CloseIcon} onClick={this.hideProgramStrip}>x</span>
                        </div>
                }

                {
                    this.state.showPopup && !IsObjectEmpty(this.state.notificationData) ?
                        <NotificationPopup
                            show={this.state.showPopup}
                            data={this.state.notificationData}
                            closeClicked={this.closeNotifButtonClick}
                        />
                        : null
                }
                {
                    this.state.showToast && !IsObjectEmpty(this.state.notificationData) ?
                        <NotificationToast
                            data={this.state.notificationData}
                            visible={this.state.showToast}
                            duration={''}
                            showTimeline={false}
                            closeToastClicked={this.closeNotifButtonClick}
                            autoHideToast={true} />
                        : null
                }

                {
                    (this.props.location.pathname === '/'
                        || this.props.location.pathname.indexOf('user/password-reset/confirm') === -1)
                        && this.props.location.pathname !== '/login'
                        && this.props.location.pathname !== '/customer-support'
                        && this.props.location.pathname.indexOf('profile/public') === -1
                        && this.props.location.pathname.indexOf('public-profile') === -1
                        && this.props.location.pathname.indexOf('public-certificate') === -1
                        && !this.props.userLoggedIn ? <Redirect to="/" /> : null
                }

                {this.state.showLiveSessionPopup ?
                    <LiveSessionPopup
                        show={this.state.showLiveSessionPopup}
                        liveSessionId={this.state.liveSessionId}
                        liveSessionData={this.props.liveSessionData}
                        data={this.state.continueLearningData.todaysPlan}
                        closeButtonClick={this.hideLiveSessionPopup}
                    /> : null}
                {/* {
                    this.state.previousTopicFeedback.feedbackSubmitted ?
                        null
                        :
                        <>
                            {
                                this.state.previousTopicFeedback.feedbackType === 'daily'
                                    ? this.state.previousTopicFeedback.subtopicExist ?
                                        <DailyFeedbackPupup
                                            show={true}
                                            feedbackId={this.state.previousTopicFeedback.feedbackId}
                                            nonCloseable={false}
                                            closePopup={this.closePopup}
                                            topicName={this.state.previousTopicFeedback.topicName}
                                        />
                                        : null
                                    : null
                            }
                            {
                                this.state.previousTopicFeedback.feedbackType === 'new daily'
                                    ? <NewDailyFeedbackPupup
                                        show={true}
                                        feedbackId={this.state.previousTopicFeedback.feedbackId}
                                        // date={this.state.currentTopic.scheduleDate || this.state.currentTopic.date}
                                        topicId={this.state.previousTopicFeedback.topicId}
                                        nonCloseable={false}
                                        closePopup={this.closePopup}
                                        topicName={this.state.previousTopicFeedback.topicName}
                                    />
                                    : null
                            }
                        </>
                } */}

                {this.props.signInModalOpen ?
                    <FlexModal visible={this.props.signInModalOpen} fullScreenMobile={true} width={document.documentElement.clientWidth < 768 && "100vw"}>
                        <SignInModalForm
                            closeButtonClick={this.onModalCloseButtonClick}
                            onResetPasswordLinkClick={this.onResetPasswordLinkClick}
                            getCommonData={this.setBasicUserDetails}
                            onSuccessDialogShow={this.props.onSuccessDialogShow}
                            onFailureDialogShow={this.props.onFailureDialogShow}
                            redirectToServerError={this.props.redirectToServerError}
                            redirectToNotFound={this.props.redirectToNotFound}
                            redirectToUnauthorized={this.props.redirectToUnauthorized}
                            showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                            singInPage={false}
                            showLineLoader={this.state.signInLoading}
                            resendVerificationEmailButtonClick={this.resendVerificationEmailButtonClick}
                        />
                    </FlexModal> : null}

                {this.props.forgotPasswordModalOpen ?
                    <FlexModal visible={this.props.forgotPasswordModalOpen}>
                        <ForgotPasswordModalForm
                            closeButtonClick={this.props.hideForgotPasswordModal}
                            onSuccessDialogShow={this.props.onSuccessDialogShow}
                            redirectToServerError={this.props.redirectToServerError}
                            redirectToNotFound={this.props.redirectToNotFound}
                            redirectToUnauthorized={this.props.redirectToUnauthorized}
                            showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                        />
                    </FlexModal> : null}

                <Topbar
                    styleclass={[this.props.topbarStyleClass, this.state.hideProgramStrip ? '' : 'WithStrip'].join(' ')}
                    onBackdropClick={this.onSearchDropdownBackdropClick}
                    topbarTheme={this.props.topbarTheme}
                    onLogoClick={this.onLogoClick}
                    loginButtonClick={this.props.showSignInPopup}
                    userLoggedIn={this.props.userLoggedIn}
                    channelId={this.props.channelId}
                    profileDropDownOpen={this.state.profileDropDownOpen}
                    onProfileAvatarClick={this.onProfileAvatarClick}
                    notificationsDropDownOpen={this.state.notificationsDropDownOpen}
                    onNotificationIconClick={this.onNotificationIconClick}
                    countChanged={this.state.countChanged}
                    notifications={this.state.notifications}
                    unreadNotifCount={this.props.unreadNotifCount}
                    logoutClicked={this.logOutClicked}
                    onViewAllNotificationsClick={this.onViewAllNotificationsClick}
                    showNotificationLoader={this.state.showNotificationLoader}
                    username={this.props.userDetails.username}
                    userProfilePic={this.props.userDetails.userProfilePic}
                    fullName={this.props.userDetails.fullName}
                    activeProgramBatchCode={this.props.activeProgramBatchCode}
                    showQuizNavbar={this.props.showQuizNavbar}
                    programType={this.props.ongoingProgram.type}
                    community={(this.state.forLearner) ? this.props.ongoingProgram.community : this.props.ongoingModule.community}
                    showMDStudentPopup={this.showMDStudentPopup}
                />
                <RedirectUtilityWrapper
                    isLoading={this.state.showLoader}
                    somethingWentWrong={this.props.somethingWentWrong}
                    notFound={this.props.notFound}
                    unauthorized={this.props.unauthorized}
                    showSuccessDialog={this.props.showSuccessDialog}
                    successDialogMessage={this.props.successDialogMessage}
                    successDialogButtonLabel={this.props.successDialogButtonLabel}
                    onSuccessDialogHide={this.props.onSuccessDialogHide}
                    showFailureDialog={this.props.showFailureDialog}
                    failureDialogMessage={this.props.failureDialogMessage}
                    failureDialogButtonLabel={this.props.failureDialogButtonLabel}
                    onFailureDialogHide={this.props.onFailureDialogHide}
                    showAlertDialog={this.state.showAlertDialog || this.props.showSessionExpiredAlertDialog === true}
                    alertDialogMessage={this.state.alertDialogMessage}
                    alertDialogButtonLabel={this.state.alertDialogButtonLabel}
                    onAlertDialogHide={this.onAlertDialogHide}>

                    <main className={[classes.Content, topbarTheme, this.state.hideProgramStrip ? '' : classes.WithStrip].join(' ')}>

                        {this.props.userLoggedIn && this.props.showProgramDetailsTopbar && !this.props.hideTopbar
                            ? <TopbarProgramStrip
                                isLearner={GetFromLocalStorage(Constants.KEY_IS_LEARNER)}
                                showModuleProgress={true}
                                showLiveSessionPopup={this.showLiveSessionPopup} /> : null}
                        {this.props.userLoggedIn && this.props.showProgramDetailsTopbar
                            ? <div>
                                <VerticalNavBar
                                    isLearner={GetFromLocalStorage(Constants.KEY_IS_LEARNER)}
                                    isB2C={this.props.ongoingProgram.isB2C}
                                    programType={this.props.ongoingProgram.type}
                                    batchCode={this.props.activeProgramBatchCode}
                                    isProgramManager={this.props.hideTopbar}
                                    moduleName={this.props.activeModuleName}
                                    accessReports={this.state.accessReports}
                                    placements={this.props.ongoingProgram.placements}
                                    hideProgramStrip={this.state.hideProgramStrip}
                                    jobs={this.props.ongoingProgram.type === 'micro_degree'}
                                    forEventBeep={this.props.ongoingProgram.type === 'event_beep'}
                                />
                            </div>
                            : null}


                        {this.props.children}
                    </main>

                    {/* <ContactSupportIcon isB2C={this.props.ongoingProgram.isB2C} /> */}
                    {
                        this.props.location.pathname === "/placements" || this.props.userLoggedIn === false
                            ? null
                            : <ContactSupportIcon isB2C={false} />
                    }

                </RedirectUtilityWrapper>
            </div >
        );
    }
}

const mapStateToProps = state => {
    return {
        topbarTheme: state.topbarTheme,
        userLoggedIn: state.userLoggedIn,
        signInModalOpen: state.signInModalOpen,
        forgotPasswordModalOpen: state.forgotPasswordModalOpen,
        activeProgramId: state.activeProgramId,
        liveSessionData: state.liveSessionData,
        hideProgramStrip: state.hideProgramStrip,

        userDetails: state.userDetails,

        activeProgramBatchCode: state.activeProgramBatchCode,
        activeModuleName: state.activeModuleName,
        unreadNotifCount: state.unreadNotifCount,
        showProgramDetailsTopbar: state.showProgramDetailsTopbar,
        showQuizNavbar: state.showQuizNavbar,
        hideTopbar: state.hideTopbar,
        ongoingProgram: state.ongoingProgramDetails,
        ongoingModule: state.ongoingModuleData,
        enrolledPrograms: state.enrolledProgramsList,

        showSuccessDialog: state.showSuccessDialog,
        successDialogMessage: state.successDialogMessage,
        successDialogButtonLabel: state.successDialogButtonLabel,
        showFailureDialog: state.showFailureDialog,
        failureDialogMessage: state.failureDialogMessage,
        failureDialogButtonLabel: state.failureDialogButtonLabel,
        somethingWentWrong: state.somethingWentWrong,
        notFound: state.notFound,
        unauthorized: state.unauthorized,
        showSessionExpiredAlertDialog: state.showSessionExpiredDialog
    };
}

const mapDisptachToProps = dispatch => {
    return {
        onUserLoginSuccess: () => dispatch(actionCreators.userLogin(true)),
        onUserLoggedOut: () => dispatch(actionCreators.userLogout(false)),
        showSignInPopup: () => dispatch(actionCreators.openSignInModal(true)),
        showForgotPasswordModal: () => dispatch(actionCreators.openForgotPasswordModal(true)),
        hideForgotPasswordModal: () => dispatch(actionCreators.openForgotPasswordModal(false)),
        hideSignInPopup: () => dispatch(actionCreators.openSignInModal(false)),
        setBasicUserDetails: (data) => dispatch(actionCreators.setBasicUserDetails(data)),
        setInitialProgramData: (continueLearningData, ongoingProgram, enrolledPrograms) => dispatch(actionCreators.setInitialProgramData(continueLearningData, ongoingProgram, enrolledPrograms)),
        setActiveProgramId: (data) => dispatch(actionCreators.setActiveProgramId(data)),
        setUnreadNotifCount: (count) => dispatch(actionCreators.setUnreadNotifCount(count)),

        setInitialModuleData: (moduleOverviewData, ongoingModule, enrolledModules) => dispatch(actionCreators.setInitialModuleData(moduleOverviewData, ongoingModule, enrolledModules)),
        setActiveModuleId: (moduleId, batchCode, moduleName) => dispatch(actionCreators.setActiveModuleId(moduleId, batchCode, moduleName)),
        hideTopbarStrip: (status) => dispatch(actionCreators.hideTopbarStrip(status)),

        onFailureDialogShow: (msg, btnLabel) => dispatch(actionCreators.onFailureDialogShow(msg, btnLabel)),
        onFailureDialogHide: () => dispatch(actionCreators.onFailureDialogHide()),
        onSuccessDialogShow: (msg, btnLabel) => dispatch(actionCreators.onSuccessDialogShow(msg, btnLabel)),
        onSuccessDialogHide: () => dispatch(actionCreators.onSuccessDialogHide()),

        redirectToUnauthorized: () => dispatch(actionCreators.redirectToUnauthorized()),
        redirectToNotFound: () => dispatch(actionCreators.redirectToNotFound()),
        redirectToServerError: () => dispatch(actionCreators.redirectToServerError()),
        showSessionExpiredDialog: (show) => dispatch(actionCreators.showSessionExpiredDialog(show))
    };
}

export default connect(mapStateToProps, mapDisptachToProps)(withRouter(MainLayout));